import moment from 'moment/moment'
import IndexController from '../index_controller'

export default class extends IndexController {
  static targets = ['confirmActivationModal', 'logToActivateName']

  connect () {
    super.connect()

    $('#sites').dropdown({})
    $('#statuses').dropdown({})

    super.initializeFromToDateFilters()
  }

  // this can be avoid if I represent main section partial
  setUIFilterDefaults () {
    this.disableFilterEvents()
    $('#sites').dropdown('clear')
    $('#statuses').dropdown('clear')
    $('#logs-search-input').val('')
    $('#from-date-filter').datepicker('clearDates')
    $('#to-date-filter').datepicker('clearDates')
    this.enableFilterEvents()
  }

  buildFilters () {
    const filters = super.buildFilters()

    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].sites = $('#sites').dropdown('get values') || []
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].statuses = $('#statuses').dropdown('get values') || []

    const fromDate = moment.utc($('#from-date-filter').data('datepicker').getDate())
    const toDate = moment.utc($('#to-date-filter').data('datepicker').getDate()).add(1, 'd').subtract(1, 's')

    if (fromDate && fromDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].from_date = fromDate.unix()
    }

    if (toDate && toDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].to_date = toDate.unix()
    }

    return filters
  }

  confirmActivation (event) {
    this.confirmActivationModalTarget.dataset.logIdToActivate = event.currentTarget.dataset.logId
    this.logToActivateNameTarget.textContent = event.currentTarget.dataset.logName
    $(this.confirmActivationModalTarget).modal('show')
  }

  activate () {
    window.location.href = `/log/activate/${this.confirmActivationModalTarget.dataset.logIdToActivate}`
  }
}
